<template>
   <v-container fluid fill-height="" class="autoPadding px-0 pt-0">
      <v-card width="315px"
    flat
    right>
        <div class="divDisplay">
          <div class="titleText">
            <h3>{{userDetail.staffFirstName}} {{userDetail.staffLastName}}</h3>
          </div>
          <v-avatar size="100" color="white">
            <img
              @error="profileImageUrl = ''"
              :src="profileImageUrl"
              v-if="profileImageUrl !== ''"
              class="profileImage" />
            <img src="@/assets/images/avatar.jpg" v-if="profileImageUrl === ''" class="profileImage" />
          </v-avatar>
        </div>
        <v-layout wrap class="pt-2">
        </v-layout>
        <v-divider class=""></v-divider>
        <v-list dense class="text-center">
          <v-list-item-group color="primary">
            <v-list-item @click="LogOut()">
              <v-list-item-content>
                <p class="mb-0">Log Out</p>
              </v-list-item-content>
            </v-list-item>
          </v-list-item-group>
        </v-list>
    </v-card>
   </v-container>
</template>
<script>
import {removeCookies} from '@/utils/cookies'
import {getStaffProfileImage} from '@/utils/common.js'
export default {
  data () {
    return {
      profileImageUrl: '',
      userDetail: {}
    }
  },
  mounted () {
    let userData = localStorage.getItem('loginuserData')
    this.userDetail = JSON.parse(userData)
    this.profileImageUrl = getStaffProfileImage(this.userDetail.staffId, 'small')
  },
  methods: {
    LogOut () {
      localStorage.clear()
      removeCookies('authToken')
      removeCookies('_SEC_PRLG2DICC')
      this.$store.dispatch('GetUserPermission', true)
      this.$router.push({name: 'emailVerify'})
    }
  }
}
</script>
<style scoped>
.divDisplay{
  text-align: center;
}
.v-application .px-0 {
  padding-right: 0!important;
  padding-left: 0!important;
  padding-bottom: 0!important;
}

</style>



// WEBPACK FOOTER //
// src/View/components/avatarmenu.vue